import React, { Component } from 'react';
import { Chart } from 'react-google-charts';

import { IsObjectEmpty, IsListEmpty } from '../../../../utilities/CommonMethods';
import ShowLoader from '../../../../hoc/ShowLoader/ShowLoader';

import classes from './PieChart.module.css';

class PieChart extends Component {

    state = {
        chartData: {},
        chartOptions: {
            title: "",
            // pieHole: 0.6,
            slices: [
                { color: "#2BA14D" },
                { color: "#FCB440" },
                { color: "#ED4A4C" }
            ],
            legend: {
                position: "none",
                alignment: "start",
                textStyle: {
                    color: "233238",
                    fontSize: 16
                }
            },
            tooltip: {
                showColorCode: true
            },
            chartArea: {
                left: 0,
                top: 0,
                width: "100%",
                height: "100%"
            },
            fontName: "Roboto"
        }
    }

    componentDidMount() {
        this.setState({ chartData: this.props.data });
    }

    componentDidUpdate(prevProps) {
        // console.log('bar chart data>>> ', this.props)
        if ((IsListEmpty(prevProps.data)) && !IsListEmpty(this.props.data)) {
            this.setState({ chartData: this.props.data });
        }
    }

    render() {
        let chartDataLoaded = !IsObjectEmpty(this.props.data) && !IsListEmpty(this.state.chartData);
        return (
            <div className={[classes.PieChartWrapper, chartDataLoaded ? '' : classes.RemoveTopMargin].join(' ')}>
                {chartDataLoaded
                    ? <Chart
                        chartType="PieChart"
                        data={this.state.chartData}
                        options={this.state.chartOptions}
                        graph_id="PieChart"
                        width={"100%"}
                        height={"auto"}
                        legend_toggle
                    />
                    : <p style={{ 'fontWeight': '500', 'fontSize': '1.1em' }}>Feedback not available</p>
                }

            </div>
        );
    }
}

export default PieChart;